import React from "react";
import "./Home.css";
import Product from "./Product.js";

function Home() {
  return (
    <div className="home">
      <div className="home_container">
        <img className="home_image" src="./banner.jpg" alt="amazon banner" />

        <div className="home_row">
          <Product
            id="124576"
            title="The Lean Startup"
            price={29.99}
            image="leanstartup.jpeg"
            rating={4}
          />
          <Product
            id="124577"
            title="Kenwood Mix Stand Mixer for Baking, Stylish Kitchen Mixer with KHeater, Dough Hook and Whisk, 5litre glass bowl"
            price={29.99}
            image="download.jpeg"
            rating={3}
          />
        </div>
        <div className="home_row">
          <Product
            id="124578"
            title="Samsung 49inch curved LED gaming monitor"
            price={29.99}
            image="led.jpeg"
            rating={3}
          />
          <Product
            id="124579"
            title="Amazon Echo 3rd generation smart speaker with Alexa, Charcoal Fabric"
            price={29.99}
            image="speaker.jpeg"
            rating={3}
          />
          <Product
            id="124580"
            title="New Apple Ipad Pro 12 inch, wifi, 128GB, Silver (4th generation)"
            price={29.99}
            image="ipad.jpeg"
            rating={3}
          />
        </div>
        <div className="home_row">
          <Product
            id="124581"
            title="Apple Watch Pro"
            price={29.99}
            image="watch.png"
            rating={3}
          />
          <Product
            id="1245782"
            title="Sofa Cum Bed"
            price={29.99}
            image="sofa.jpeg"
            rating={3}
          />
          <Product
            id="124583"
            title="Air Conditioner"
            price={29.99}
            image="ac.png"
            rating={3}
          />
        </div>
      </div>
    </div>
  );
}

export default Home;
